import { useQuery } from '@tanstack/react-query';
import { NotificationQueryKeys } from './notifications.keys';
import apiClient from '../ApiClient';

const getNotifications = async (): Promise<any> => {
    const res = await apiClient.get('notifications');
    return res.data?.data;
};

export const useFetchNotifications = () => {
  return useQuery({
    queryKey: NotificationQueryKeys.all,
    queryFn: () => getNotifications(),
  });
};
